// frontend/src/components/Header.jsx
import React from 'react';
import { LogOut, User } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

function Header({ user }) {
    const { logout } = useAuth();

    return (
        <header style={{
            backgroundColor: '#fff',
            borderBottom: '1px solid #e2e8f0',
            padding: '1rem 0',
            marginBottom: '20px',
            boxShadow: '0 1px 2px 0 rgba(0,0,0,0.05)'
        }}>
            <div className="container" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                
                {/* ?? CLICKABLE LOGO & TITLE (HOME LINK) */}
                <div 
                    onClick={() => window.location.href = '/'} 
                    style={{ display: 'flex', alignItems: 'center', gap: '10px', cursor: 'pointer' }}
                    title="Return to Dashboard"
                >
                    <div style={{ 
                        width: '32px', height: '32px', backgroundColor: '#0d9488', 
                        borderRadius: '6px', display: 'flex', alignItems: 'center', 
                        justifyContent: 'center', color: 'white', fontWeight: 'bold'
                    }}>P</div>
                    <h1 style={{ fontSize: '1.25rem', fontWeight: 'bold', color: '#1e293b', margin: 0 }}>
                        PolyUnity <span style={{ color: '#64748b', fontWeight: 'normal' }}>Print Farm Maintenance</span>
                    </h1>
                </div>

                {/* User Profile & Logout */}
                {user && (
                    <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '0.9rem', color: '#334155' }}>
                            {user.picture ? (
                                <img src={user.picture} alt="Profile" style={{ width: 28, height: 28, borderRadius: '50%' }} />
                            ) : (
                                <User size={20} />
                            )}
                            <span style={{ fontWeight: 500, display: 'none', sm: 'inline' }}>{user.name}</span>
                        </div>
                        <button 
                            onClick={logout} 
                            title="Logout"
                            style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 5, color: '#ef4444', width: 'auto' }}
                        >
                            <LogOut size={20} />
                        </button>
                    </div>
                )}
            </div>
        </header>
    );
}

export default Header;